var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgParts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23.437,
    height: 23.437,
    viewBox: "0 0 23.437 23.437",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.437,
    height: 23.437,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_660",
    "data-name": "Group 660",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_571",
    "data-name": "Group 571",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_415",
    "data-name": "Path 415",
    d: "M19.626,27.119a.352.352,0,0,1-.248-.1l-6.95-6.952a.351.351,0,1,1,.5-.5l6.7,6.7,6.647-6.647-6.7-6.7a.351.351,0,1,1,.5-.5l6.951,6.952a.35.35,0,0,1,0,.5l-7.143,7.143a.352.352,0,0,1-.248.1",
    transform: "translate(-3.683 -3.682)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_416",
    "data-name": "Path 416",
    d: "M19.4,24.519a.353.353,0,0,1-.248-.1l-7.8-7.8a.352.352,0,0,1,0-.5l4.765-4.764a.36.36,0,0,1,.5,0l7.8,7.8a.351.351,0,0,1,0,.5l-4.764,4.765a.353.353,0,0,1-.248.1m-7.3-8.147,7.3,7.3L23.671,19.4l-7.3-7.3Z",
    transform: "translate(-3.363 -3.365)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_417",
    "data-name": "Path 417",
    d: "M10.018,12.7a.35.35,0,0,1-.248-.1l-7.8-7.8a.352.352,0,0,1,0-.5L4.307,1.976a.359.359,0,0,1,.5,0l7.8,7.8a.35.35,0,0,1,0,.5L10.266,12.6a.355.355,0,0,1-.248.1m-7.3-8.147,7.3,7.3,1.836-1.836-7.3-7.3Z",
    transform: "translate(-0.559 -0.561)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418",
    "data-name": "Path 418",
    d: "M28.758,30.966A2.2,2.2,0,0,1,27.2,27.211a2.252,2.252,0,0,1,3.111,0,2.2,2.2,0,0,1-1.555,3.755m0-3.7a1.5,1.5,0,0,0-1.06,2.558,1.534,1.534,0,0,0,2.12,0,1.5,1.5,0,0,0-1.06-2.558",
    transform: "translate(-7.936 -7.944)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419",
    "data-name": "Path 419",
    d: "M1.8,3.6a1.8,1.8,0,1,1,1.275-.527A1.8,1.8,0,0,1,1.8,3.6M1.8.7a1.1,1.1,0,1,0,.779.323A1.1,1.1,0,0,0,1.8.7",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_420",
    "data-name": "Path 420",
    d: "M2.268,6.3a.351.351,0,0,1-.248-.6L5.7,2.02a.351.351,0,0,1,.5.5L2.516,6.2a.352.352,0,0,1-.248.1",
    transform: "translate(-0.573 -0.573)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_421",
    "data-name": "Path 421",
    d: "M4.78,8.811a.351.351,0,0,1-.248-.6L8.213,4.531a.351.351,0,0,1,.5.5L5.028,8.709a.352.352,0,0,1-.248.1",
    transform: "translate(-1.323 -1.323)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_422",
    "data-name": "Path 422",
    d: "M7.291,11.323a.351.351,0,0,1-.248-.6l3.682-3.682a.351.351,0,0,1,.5.5L7.539,11.221a.352.352,0,0,1-.248.1",
    transform: "translate(-2.074 -2.073)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    "data-name": "Path 423",
    d: "M9.8,13.834a.351.351,0,0,1-.248-.6l3.682-3.682a.351.351,0,0,1,.5.5L10.05,13.732a.352.352,0,0,1-.248.1",
    transform: "translate(-2.824 -2.824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424",
    "data-name": "Path 424",
    d: "M4.779,8.061a.363.363,0,0,1-.117-.02.351.351,0,0,1-.214-.447L6.37,2.151a.351.351,0,1,1,.661.233L5.11,7.827a.351.351,0,0,1-.331.234",
    transform: "translate(-1.323 -0.573)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_425",
    "data-name": "Path 425",
    d: "M7.29,10.573a.363.363,0,0,1-.117-.02.352.352,0,0,1-.214-.448L8.881,4.662a.351.351,0,1,1,.661.234L7.621,10.339a.352.352,0,0,1-.331.234",
    transform: "translate(-2.073 -1.323)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_426",
    "data-name": "Path 426",
    d: "M9.8,13.084a.363.363,0,0,1-.117-.02.352.352,0,0,1-.214-.448l1.921-5.443a.351.351,0,1,1,.661.233L10.132,12.85a.351.351,0,0,1-.331.234",
    transform: "translate(-2.824 -2.074)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_427",
    "data-name": "Path 427",
    d: "M12.314,15.595a.363.363,0,0,1-.117-.02.352.352,0,0,1-.214-.448L13.9,9.685a.351.351,0,1,1,.661.233l-1.921,5.443a.351.351,0,0,1-.331.234",
    transform: "translate(-3.574 -2.824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_428",
    "data-name": "Path 428",
    d: "M19.153,22.433a.352.352,0,0,1-.248-.1l-4.157-4.157a.351.351,0,1,1,.5-.5L19.4,21.834a.351.351,0,0,1-.248.6",
    transform: "translate(-4.376 -5.251)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_429",
    "data-name": "Path 429",
    d: "M22.921,26.2a.352.352,0,0,1-.248-.1l-.655-.656a.351.351,0,1,1,.5-.5l.656.655a.351.351,0,0,1-.248.6",
    transform: "translate(-6.548 -7.423)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParts);
export default __webpack_public_path__ + "static/media/parts.6305d7e0286f9f601eac710213333042.svg";
export { ForwardRef as ReactComponent };